if (document.body.classList.contains('single-product')) {
  const toggleButton = document.querySelector('#toggle-tryon');
  if (toggleButton) {
    (function () {
      const config = {
        partner_id: 'pnKDCSpEe7',
        locale: 'no',
        env: 'prod',
        disablePersist: true,
        liveARState: 'renderingEffects',
        renderTo: document.querySelector('#revieve-container'),
        onClose: function() {
          const toggleButton = document.querySelector('#toggle-tryon');
          if (toggleButton) {
            toggleButton.classList.remove('hidden');
            document.body.classList.remove('tryon-open');
            // document.querySelector('.image-gallery-container').classList.remove('hidden');
            document.querySelector('#revieve-iframe').style.display = 'none';
          }
        }
      };

      const toggleButton = document.querySelector('#toggle-tryon');
      if (toggleButton) {
        toggleButton.addEventListener('click', (event) => {
          event.preventDefault();

          toggleButton.classList.add('hidden');
          document.body.classList.add('tryon-open');
          // document.querySelector('.image-gallery-container').classList.add('hidden');
          document.querySelector('#revieve-iframe').style.display = '';
        });
      }

      const rv = document.createElement('script');
      rv.src = 'https://d38knilzwtuys1.cloudfront.net/revieve-plugin-v4/revieve-plugin-loader.js';
      rv.charset = 'utf-8';
      rv.type = 'text/javascript';
      rv.async = 'true';
      rv.onload = rv.onreadystatechange = function () {
        const rs = this.readyState;
        if (rs && rs != 'complete' && rs != 'loaded') return;
        Revieve.Init(config, () => {
          const { postId } = document.body.dataset;
          Revieve.API.liveAR.addTryOnProduct(postId);
          Revieve.API.show();
          document.querySelector('#revieve-iframe').style.display = 'none';
        });
      };
      const s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(rv, s);
    }());
  }
}
